import { CLEAR_PRODUCTS, GET_PRODUCTS, SET_PRODUCTS } from './actions'

export const productsReducer = (state, action) => {
  switch (action.type) {
    case GET_PRODUCTS:
      return { ...state, loading: true, category: action.category }
    case CLEAR_PRODUCTS:
      return {
        loading: false,
        category: {},
        productId: null,
        products: { collection: [] }
      }
    case SET_PRODUCTS:
      return {
        ...state,
        products: {
          collection: action.products?.collection || []
        },
        category: action.category,
        productId: action.productId,
        loading: false
      }
    default:
      return state
  }
}
